import { SVGProps } from "react";

/**
 * Figma `arrow-down-01` caret used by the header outlet dropdown.
 * The glyph is authored at 9.79549 x 5.69324 and sits at (4.10215, 6.3522)
 * inside the design's 18 x 18 icon box.
 */
const ArrowDown01 = ({
  width = 18,
  height = 18,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <g transform="translate(4.10215 6.3522)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79549 0.795492L4.89778 5.69324L0 0.795532L0.795489 3.10689e-05L4.89778 4.10225L8.99999 0L9.79549 0.795492Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default ArrowDown01;
